import styled from 'styled-components';
import { Text, FlexRow } from '@make-software/tg-mini-app-ui';

export const StyledTitle = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px'
  })
);

export const StyledContentWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    marginTop: '20px'
  })
);

export const Title = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '28px'
  })
);

export const Subtitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '28px',
    fontFamily: 'Inter'
  })
);

export const StyledHash = styled.div(({ theme }) =>
  theme.withMedia({
    color: '#FFF',
    fontSize: '12px',
    fontWeight: '400',
    width: '100px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  })
);

export const StyledContent = styled.div(({ theme }) =>
  theme.withMedia({
    padding: '16px 20px 0 20px'
  })
);

export const ContentWindow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    padding: '16px',
    height: '52px',
    backgroundColor: '#30313B',
    borderRadius: '8px',
    border: '1px solid #41424E',
    marginBottom: '20px'
  })
);

export const ButtonWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '12px'
  })
);

export const SvgContainer = styled.div<{ openFilterMenu?: boolean }>(
  ({ theme, openFilterMenu = false }) =>
    theme.withMedia({
      padding: '8px',
      alignItems: 'center',
      display: 'flex',
      cursor: 'pointer',
      borderRadius: '4px',
      border: '1px solid #41424E',
      backgroundColor: openFilterMenu ? '#3A3B46' : '#30313B',
      position: 'relative'
    })
);

export const Dot = styled.div(({ theme }) =>
  theme.withMedia({
    width: 8,
    height: 8,
    backgroundColor: '#F86F6A',
    position: 'absolute',
    top: -3,
    right: -4,
    borderRadius: '50%'
  })
);

export const EmptyProjectTitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#FFF',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const EmptyProjectSubtitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    textAlign: 'center',
    fontFamily: 'Inter'
  })
);

export const ErrorText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '140%',
    color: '#FB6F6A',
    fontFamily: 'Inter'
  })
);
